<template>
<section>
<div class="container mt-2">
  <div class="card mt-2">
    <h5 class="card-header text-start text-success">关于我们</h5>
    <div class="card-body">
      <p class="card-title text-start"><b class="c-red">三鱼公司</b> 是富渔国际旗下品牌之一</p>
      <div class="container">
        <div class="row">
          <div class="col-4"><img src="@/assets/about2.jpg" width="100%" /></div>
          <div class="col-4"><img src="@/assets/about1.jpg" width="100%" /></div>
          <div class="col-4"><img src="@/assets/ywcq_3.jpg" width="100%" /></div>
        </div>
        <div class="row mt-2">
          <div class="col text-start">
            <p class="card-title text-start"><b>我们的宗旨</b></p>
            <ul style="list-style-type: circle;">
              <li>致力于为餐厅超市提供健康营养的海鲜产品</li>
              <li>精准了解客户需求</li>
              <li>用心提供优质服务</li>
              <li>为客户创造价值</li>
              <li>帮助客人获得成功</li>
            </ul>
          </div>
        </div>
      </div>
      <p class="card-title text-start"><b>我们的团队</b></p>
      <div class="container">
        <div class="row">
          <div class="col text-start">
            <ul style="list-style-type: circle;">
            <li>3Fish 的产品，追求的不仅仅是安全与可持续，更关注消费者的健康，我们的海鲜品种多样，我们的产品研发团队将世界各地高品质的商品带给我们的消费者</li>
            <li>我们有专业的运输团队，保证将我们的产品精确地送到客户手中</li>
            <li>我们有联邦注册的加工厂，满足多种多样的加工需求</li>
            <li>我们有完善的仓库管理系统以及多个大型冷库，让我们的客户不用为货源短缺而困扰</li>
            <li>随时随地，无论餐厅还是超市，三鱼海鲜，天天见!</li>
            </ul>
          </div>
        </div>
      </div>
      <p class="card-title text-start"><b>我们的大厨</b></p>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="card shadow-sm">
              <img class="card-img-top" src="@/assets/jasonchef.jpg" width="100%" role="img" aria-label="Placeholder:Album" preserveAspectRatio="xMidYMid slice" focusable="false">
              <div class="card-body">
                  <p class="card-text">中餐大厨 Jason Wu (伍伟强)</p>
                  <p class="text-left" style="text-align:left !important">
                    伍伟强大厨，坚持发扬中餐传统烹饪技法，融汇世界各地不同元素创造出风味独特，层次丰富的创新菜式。他任职万豪酒店(Parq Vancouver)内的1886 Chinese fine dining and Market East行政总厨期间，就以才是新颖，料理手法独特而闻名于本地餐饮界。
                    在主理1885之前，伍大厨作为特朗普酒店内知名中餐厅Mott 32 fine dining的特邀厨师创始团队成员之一，其出品菜色品味俱佳，给予了食客多重感官的享受，亦受到挑剔的温哥华饕客的广泛赞誉。
                  </p>
                  <p class="text-left" style="text-align:left !important">
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                  <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
                  </div>
                  <van-icon name="like-o" class="c-red" />
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p></p>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="card shadow-sm">
              <img class="card-img-top" src="@/assets/poyanchef.jpg" width="100%" role="img" aria-label="Placeholder:Album" preserveAspectRatio="xMidYMid slice" focusable="false">
              <div class="card-body">
                  <p class="card-text">西餐大厨 Poyan Danesh</p>
                  <p class="text-left" style="text-align:left !important">
                    Chef Poyan has been heavily involved in the BC culinary scene since graduating top of his class at VCC. Poyan is currently Culinary Director at Ocean Mama Seafood.
                  </p>
                  <p class="text-left" style="text-align:left !important">
                    Named 2013 BC Chef of the year, he was also one of 4 chefs that represented Canada in the World Culinary Olympics in Germany in 2012, placing 4th in the world. He was also honored with the position of Captain of the Olympic Culinary Team of BC where he led them to a gold in their category, and 4th place finish at the World Culinary Olympics in Germany October of 2008. Poyan was also a member of Culinary Team Canada from 2004 competing twice in Luxembourg, Basel and in Chicago with a second place finish, winning 6 gold medals in total.
                  </p>
                  <p class="text-left" style="text-align:left !important">
                    He was also on the Board of Directors as Vice President of the BC Chefs association from 2009 – 2013.

Poyan was featured on the Global series “Canada’s Next Great Chef” as BC’s culinary representative. Poyan has also won the honor of being BC’s apprentice of the year and has won many Grand Gold championships at regional competitions around the city. He has also been awarded the Top in Trades award by the Province newspaper and was named one of Vancouver’s rising stars by the Vancouver Sun and VCC alumni of the year in 2007.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                  <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
                  </div>
                  <van-icon name="like-o" class="c-red" />
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</section>
</template>
<script>
  import {onMounted} from 'vue'
  import $ from 'jquery'
  export default {
    name: 'about',
    components: {},
    emits: ['viewLoaded'],
    setup(props,ctx) {
      onMounted(() => {
        ctx.emit('viewLoaded','about')
      })
      const readAll = () => {
        $('#article-summary').removeClass('text-primary');
        $('#read-all').addClass('d-none');
        $('#article-rest').removeClass('d-none')
      }

      return {readAll}
    }
  };
</script>
<style lang="scss" scoped>
#certificate {
  padding-top: 10px;
  .col-lg-4 { padding-top: 10px;}
  h4 {margin-top:5px;}
  @media only screen and (min-width: 1024px) {
      #mobile-certificate {display:none;}
  }
  @media only screen and (max-width: 500px) {
      #desktop-certificate {display:none;}
  }
}

</style>
